import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type Site = ObjectId & {
  name?: string;
  slug?: string;
};

type SiteAlreadyExistsErrorOptions = {
  site: Site;
  project: ObjectId;
};

export class SiteAlreadyExistsError extends FleekError<SiteAlreadyExistsErrorOptions> {
  public name = 'SiteAlreadyExistsError';

  toString = () => {
    if ('name' in this.data.site) {
      return `Site ${this.data.site.name} already exists in the project.`;
    }

    return `Site slug must be unique within Fleek but ${this.data.site.slug} already exists.`;
  };
}
